"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
const contexts_1 = require("@App/contexts");
const validate_1 = require("@App/helpers/validate");
const SearchResult_1 = __importDefault(require("@Components/WorkRegistrationSubs/SearchResult"));
const PublisherSearchResultsTable = ({ suggestedTitle, itemWasAdded, setFoundPublisherToDraft, showMLCPublisherNumber, buttonText, }) => {
    const { publisherSearchStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const searchResult = publisherSearchStore.publisherSearchModel;
    const isValidIPI = (ipiNumber) => (ipiNumber ? (0, validate_1.IPIValidator)(ipiNumber, true) : true);
    const publisherRoles = (model) => {
        const roles = [];
        if (isValidIPI(model.ipiNumber) && model.ipiNumber) {
            roles.push({ name: 'IPI', value: model.ipiNumber });
        }
        if (showMLCPublisherNumber && model.hfaPublisherNumber) {
            roles.push({ name: 'Publisher Number', value: model.hfaPublisherNumber });
        }
        return roles;
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        suggestedTitle && react_1.default.createElement("p", { className: 'suggested-title' }, suggestedTitle),
        react_1.default.createElement("div", { className: 'suggested' }, searchResult.results.map(({ entity }, index) => {
            var _a;
            return (react_1.default.createElement(SearchResult_1.default, { key: (_a = entity.ipId) !== null && _a !== void 0 ? _a : index, title: entity.publisherName, onAddClicked: () => setFoundPublisherToDraft(entity), onItemWasAdded: itemWasAdded, roles: publisherRoles(entity), addButtonText: buttonText }));
        }))));
};
exports.default = (0, mobx_react_1.observer)(PublisherSearchResultsTable);
